import { render } from "./TrialsEditor.vue?vue&type=template&id=74d87646&scoped=true"
import script from "./TrialsEditor.vue?vue&type=script&lang=js"
export * from "./TrialsEditor.vue?vue&type=script&lang=js"

import "./TrialsEditor.vue?vue&type=style&index=0&id=74d87646&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d87646"]])

export default __exports__